import Vue from 'vue';

const getMultiplier = exp => Math.pow(10, exp);

export default {
    async getAll() {
        return (await Vue.http.get('/api/currencies')).data;
    },
    format(sourceAmount, currencyId, maximumFractionDigits, alwaysLeft, currentLocale = Vue.state.lang.currentLocale) {
        let currency = Vue.state.currencies.getCurrency(currencyId);
        if (!currency.symbol && currencyId) 
            currency = { decimals: 2, symbol: currencyId };

        // if currentLocale === null, then locale = undefined
        // then format(3000) === 3 000 
        const locale = currentLocale !== null ? currentLocale : undefined;
        let amount = sourceAmount / getMultiplier(currency.decimals);

        const localeOptions = {};
        if (typeof maximumFractionDigits === 'number') {
            localeOptions.minimumFractionDigits = Math.min(currency.decimals, maximumFractionDigits);
            localeOptions.maximumFractionDigits = maximumFractionDigits;
        } else {
            localeOptions.minimumFractionDigits = currency.decimals;
        }
        // if decimals === 0, then do the conversion downwards to match the balance in the game
        if (maximumFractionDigits === 0) {
            amount = Math.floor(amount);
        }
        const amountStr = amount.toLocaleString(locale, localeOptions);
        if (alwaysLeft) return `${currency.symbol} ${amountStr}`;
        return currency.symbol && currency.symbol.length === 1 ? `${currency.symbol}${amountStr}` : `${amountStr} ${currency.symbol}`;
    },
    fromSource(amount, currencyId) {
        const currency = Vue.state.currencies.getCurrency(currencyId);
        return amount / getMultiplier(currency.decimals);
    },
    toSource(amount, currencyId) {
        const currency = Vue.state.currencies.getCurrency(currencyId);
        return parseInt(amount * getMultiplier(currency.decimals));
    },
    formatInvariant(sourceAmount, currencyId) {
        const currency = Vue.state.currencies.getCurrency(currencyId);
        const amount = sourceAmount / getMultiplier(currency.decimals);
        return amount.toFixed(currency.decimals);
    },
    getMinimal(currencyId) {
        const currency = Vue.state.currencies.getCurrency(currencyId);
        const amount = 1 / getMultiplier(currency.decimals);
        return amount.toFixed(currency.decimals);
    }
};



// WEBPACK FOOTER //
// ./_common/services/currency.service.js